import { Text } from "@/components/ui/baseUi/text"
import { formatCurrency } from "@/modules/currency/currency"
import type { PayoutItemEntity } from "@/modules/finances/financesPayout/entities/payoutEntity"
import { useLanguage } from "@/modules/language/hooks/useLanguage"
import { cn } from "@/modules/lib/utils"
import dayjs from "dayjs"

export function PayoutAmountCell({ payout }: { payout: PayoutItemEntity }) {
  const language = useLanguage()

  return (
    <Text className="text-textDefault-body" fontStyle="TS">
      {formatCurrency(payout.amount || 0, payout.currency, language)}
    </Text>
  )
}

export function PayoutStatusCell({ payout }: { payout: PayoutItemEntity }) {
  return (
    <div className="flex flex-col">
      <Text className={cn(payout.getPayoutStatusColor())} fontStyle="LL">
        {payout.getPayoutStatusWord()}
      </Text>
      <Text className={cn(payout.getPayoutStatusDetailsColor())} fontStyle="BM">
        {payout.getPayoutStatusDetailsWord()}
      </Text>
    </div>
  )
}

export function PayoutDateCell({ payout }: { payout: PayoutItemEntity }) {
  return (
    <Text className="text-textDefault-body" fontStyle="BM">
      {dayjs(payout.createdAt).format("L")}
    </Text>
  )
}

export function PayoutBankNameCell({ payout }: { payout: PayoutItemEntity }) {
  return (
    <Text className="text-textDefault-body" fontStyle="BM">
      {payout.last4Digits && payout.bankName ? `${payout.bankName} ${payout.getFormatedDigits()}` : "- "}
    </Text>
  )
}

export function PayoutIncludedDateRangeCell({ payout }: { payout: PayoutItemEntity }) {
  if (payout.intervalStartDate && payout.intervalEndDate) {
    return (
      <div className="flex flex-row items-center gap-2">
        <Text className="text-textDefault-body" fontStyle="BM">
          {dayjs(payout.intervalStartDate).format("L")}
        </Text>
        <Text className="text-textDefault-body" fontStyle="BM">
          -
        </Text>
        <Text className="text-textDefault-body" fontStyle="BM">
          {dayjs(payout.intervalEndDate).format("L")}
        </Text>
      </div>
    )
  }
  return (
    <Text className="text-textDefault-body" fontStyle="BM">
      {"--"}
    </Text>
  )
}
